__turbopack_context__.v({
  "count": "FdBNIG_count",
  "label": "FdBNIG_label",
  "root": "FdBNIG_root",
});
